const isFormFilled = (form, values) => {
    const reduceFunc = (lv, cv) => {
        if (cv.get('options').size) {
            if (cv.get('type') == 'date'){
                return lv && !!values.get('birthDay') && !!values.get('birthMonth') && !!values.get('birthYear')
            } else {
                return lv && !!values.get(cv.get('name')) && !!values.get(cv.getIn(['options', 0, 'name']))
            }
        } else {
           return lv && !!values.get(cv.get('name')) 
        } 
    }


    const formButtonEnabled = form && 
        values && 
        form
            .filter(v => v.get('required') == true)
            .reduce(reduceFunc, true)

    return formButtonEnabled
}

export { 
	isFormFilled
}